import React, { useEffect, useReducer, useState } from "react";
import { Button, ButtonToolbar, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import PhysicianAuthorization from "../../api/models/addOnTesting/PhysicianAuthorization";
import { APIError } from "../../api/ObservableFromFetch";
import { getPhysicianAuthorization } from "../../api/ShoppingCart";
import { stringToArray } from "../../formatters/stringToArray";
import { useTranslationWithRef } from "../../hooks/useTranslationWithRef";
import { DatumLoader } from "../DataLoader";

interface PhysicianAuthorizationProps {
  testEventId: number
  onBack: () => void
  onNext: () => void
  invalidate: () => void
}

export function PhysicianAuthorizationStep({ testEventId, onBack, onNext, invalidate }: PhysicianAuthorizationProps) {
  const [translationRef, t] = useTranslationWithRef()
  const [result, setResult] = useReducer((state: DatumLoader<PhysicianAuthorization>, newState: Partial<DatumLoader<PhysicianAuthorization>>) => ({ ...state, ...newState }), { loading: true, loaded: false })
  const [rejected, setRejected] = useState<boolean>(false)

  useEffect(() => {
    const subscription = getPhysicianAuthorization(testEventId).subscribe({
      next: (response: PhysicianAuthorization) => {
        setResult({ loading: false, loaded: true, data: response })
        if (response.success) {
          if (response.rejected?.length) {
            invalidate()
            setRejected(true)
            return
          }
          onNext()
        }
      },
      error: (e: APIError) => {
        setResult({ loading: false })
        toast.error(translationRef.current(e.message, { data: e.data }))
      }
    })

    return () => subscription.unsubscribe()
  }, [testEventId, translationRef])

  return <>
    {result.loading && <Spinner animation="border" role="status" size="sm" className="mx-1"><span className="visually-hidden"></span></Spinner>}
    {result.loaded && !result.data?.success && <span className="text-danger">{t("shoppingCart.physicianAuthorizationError")}</span>}
    {rejected && stringToArray(t("shoppingCart.unauthorizedTesting")).map(item => <p className="text-primary h5 mb-3">{item}</p>)}
    {rejected && <ButtonToolbar className="justify-content-end">
      <Button onClick={onBack}>
        {t("shared.button.continue")}
      </Button>
    </ButtonToolbar>}
  </>
}
